import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { useAppSelector } from "app/redux/hooks";
import { IOrcamento } from "app/types/IOrcamento";
import { IProduto } from "app/types/produto/IProduto";
import { tratamentoErroPadrao } from "app/use-cases";
import { adicionarItens } from "app/use-cases/orcamento/adicionarItens";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useState } from "react";
import { useEffect, useRef } from "react";
import { DadoPesquisaCorTintometrico, FiltroPesquisaCorTintometrico, PesquisaCorTintometrico } from "./PesquisaCorTintometrico";
import { set } from "date-fns";

export type PesquisaCorTintometricoContainerProps = {
  onVoltar: () => void
  onAdicionadoComSucesso: () => void
  passos: Dict<string, () => void>
  regiaoRenderizada: string
  orcamentoForaModuloVendas: boolean
};

export const PesquisaCorTintometricoContainer = (
  props: PesquisaCorTintometricoContainerProps
) => {
  const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))
  const [listaSistemaTintometrico, setListaSistemaTintometrico] = useState([])
  const [dadosTabelaPesquisaCor, setDadosTabelaPesquisaCor] = useState<PagedMessageResponse<DadoPesquisaCorTintometrico>>({})
  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
  const [processando, setProcessando] = useState<boolean>(false)

  const onVoltar = () => {
    if (processando) return
    props.onVoltar()
  }

  const obterListarSistemaTintometrico = async () => {
    setDadosTabelaPesquisaCor({})
    try {
      globalMU.blockUI();
      const resposta = await microuniversoApi.Produto.listarSistemaTintometrico();
      setListaSistemaTintometrico(resposta);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();

    };
  }

  const onPesquisar = async (filtro: FiltroPesquisaCorTintometrico) => {
    try {
      setProcessando(true)
      globalMU.blockUI();
      const resposta = await microuniversoApi.Produto.PesquisarCores(filtro);
      setDadosTabelaPesquisaCor(resposta);
      if(resposta?.RowsCount == 0) globalMU.showWarnMessage("Nenhum registro encontrado.")
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
      setProcessando(false)
    };
  }

  const onAdicionar = async (produtos: string[]) => {
    try {
      setProcessando(true)
    const  itensSelecionados = produtos.map(p => ( {Codigo: p.split("|")[1], Quantidade: Number(p.split("|")[2]), CorTinta: {Codigo: p.split("|")[0]} } as IProduto))
    if (itensSelecionados?.length == 0) { globalMU.showWarnMessage("Selecione os itens que deseja adicionar."); return }
    const resposta = await adicionarItens(orcamento.IdentificadorOrcamento, itensSelecionados)

    if (!("hasErrors" in resposta)) { props.onAdicionadoComSucesso() }
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      setProcessando(false)
    }
  }

  useEffect(() => {
    obterListarSistemaTintometrico()
  }, [])

  return <>
    <Breadcrumb2Container
      passos={passosInterno.current.set("Pesquisar Cores", () => { }).keysToList()}
      exibirBotaoLimpar={false}
      exibirBotaoVoltar={true}
      processando={processando}
      id="PesquisaCorTintometricoContainer"
      onPassoSelecionado={(passo: string) => {
        passosInterno.current.get(passo)()
      }}
      onBotaoVoltarClicado={onVoltar}
    />

    <PesquisaCorTintometrico
      filtro={null}
      dadosTabelaPesquisaCor={dadosTabelaPesquisaCor}
      onPesquisar={onPesquisar}
      onAdicionar={onAdicionar}
      fabricantes={listaSistemaTintometrico}
      orcamentoForaModuloVendas={props.orcamentoForaModuloVendas}
      somenteLeitura={orcamento.SomenteLeitura}
      processando={processando}
    />
  </>
}
